"use strict";

exports.__esModule = true;
exports.default = exports.StyledContainer = void 0;

var _stitches = require("../theme/stitches.config");

const StyledContainer = (0, _stitches.styled)('div', {
  w: '100%',
  mr: 'auto',
  ml: 'auto',
  variants: {
    fluid: {
      true: {
        maxWidth: '100%'
      }
    },
    responsive: {
      true: {
        '@xs': {
          maxWidth: '$breakpoints$xs'
        },
        '@sm': {
          maxWidth: '$breakpoints$sm'
        },
        '@md': {
          maxWidth: '$breakpoints$md'
        },
        '@lg': {
          maxWidth: '$breakpoints$lg'
        },
        '@xl': {
          maxWidth: '$breakpoints$xl'
        }
      }
    }
  },
  defaultVariants: {
    fluid: false,
    responsive: true
  }
});
exports.StyledContainer = StyledContainer;
var _default = StyledContainer;
exports.default = _default;